import { render, staticRenderFns } from "./outStockOrder.vue?vue&type=template&id=35024e8b"
import script from "./outStockOrder.vue?vue&type=script&lang=js"
export * from "./outStockOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../erp_vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports